import { BUSINESS_TYPE_API_FAILED, BUSINESS_TYPE_API_REQUEST, BUSINESS_TYPE_API_SUCCESS } from "./BusinessTypesActionTypes";

const initialState = {
    loading: false,
    message: "",
    businessTypes: [],
    error: {},
}
export default function BusinessTypesReducer(state = initialState, action) {
    //
    const { type, payload, message, loading, error } = action;
    switch (type) {
        case BUSINESS_TYPE_API_REQUEST:
            return {
                loading,
            }
        case BUSINESS_TYPE_API_SUCCESS:
            return {
                loading,
                businessTypes: payload,
                message
            }
        case BUSINESS_TYPE_API_FAILED:
            return {
                loading,
                message,
                error
            }
        default:
            return state
    }
}